import { useEffect } from 'react';
import { useIntl } from '@doxyme/locale';
import { toast } from '@doxyme/ui/components';
import { getProviderName } from '../../features/realtime/realtime.selectors';
import { useAppSelector } from '../useReduxToolkit';

export type UsePatientCallResumedNotificationProps = {
  isCallResumed: boolean;
};

export const usePatientCallResumedNotification = ({
  isCallResumed,
}: UsePatientCallResumedNotificationProps) => {
  const { formatMessage } = useIntl();
  const providerName =
    useAppSelector(getProviderName) ?? formatMessage({ id: 'provider' });

  useEffect(() => {
    if (isCallResumed) {
      toast.success({
        title: formatMessage(
          { id: 'notification.resumedCallPatient' },
          { providerName },
        ),
      });
    }
  }, [isCallResumed, providerName]);
};
